"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getBlockForIndex_1 = __importDefault(require("../query/getBlockForIndex"));

var id_1 = __importDefault(require("../EditorState/id"));

var constants_1 = require("../constants");

function splitBlock(editorState, start, end) {
  var _getBlockForIndex_1$d = getBlockForIndex_1.default(editorState.list.value, start),
      currentBlock = _getBlockForIndex_1$d.block;

  var blockEnd = {
    type: 'block-end'
  };
  var blockStart = Object.assign({
    styles: []
  }, currentBlock, {
    type: 'block-start',
    blockKey: id_1.default()
  });
  return editorState.change({
    isBoundary: true,
    type: constants_1.COMMAND.SPLIT_BLOCK,
    start: start,
    end: end,
    value: [blockEnd, blockStart]
  }).change({
    type: constants_1.COMMAND.SPLIT_BLOCK,
    start: start + 2,
    end: start + 2,
    value: []
  });
}

exports.default = splitBlock;